
import { defineComponent } from "vue";
import { useMediaQuery } from "@vueuse/core";
//import BackgroundVideo from "@/components/BackgroundVideo.vue";
export default defineComponent({
  components: {
    //BackgroundVideo
  },
  setup() {
    const baseURL = process.env.BASE_URL;
    const videoURL = `${baseURL}video/AMFF_web_background_weboptimized3.mp4`;
    const isMobile = useMediaQuery("(max-width: 1023px)");

    return { videoURL, isMobile, baseURL };
  },
});
